import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { AvMutation } from '../../../core/av-api';

@Component({
  selector: 'cap-kompakt-av-mutation',
  templateUrl: './kompakt-av-mutation.component.html',
  styleUrls: ['./kompakt-av-mutation.component.scss'],
  imports: [NgTemplateOutlet]
})
export class KompaktAvMutationComponent extends KompaktdarstellungTemplateComponent {
  @Input() item: AvMutation;

  @ViewChild('gbtyp00', { static: true }) gbTyp00Template: TemplateRef<any>;

  constructor(formatService: FormatConfigService, location: PlatformLocation, locationStrategy: ComponentLocationStrategy) {
    super(formatService, 'AVMUTATION', location, locationStrategy);
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.gbTyp00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.gbTyp00Template, 'AVMUTATION_TYP00');
  }
}
